import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './heading.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { ifDefined } from 'lit/directives/if-defined.js';

export default class Heading extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      level: { type: Number },
      levelStyle: { type: String },
      color: { type: String },
      removeRole: { type: Boolean },
      id: { type: String },
    };
  }

  render() {
    if (this.level && !this.removeRole) {
      this.setAttribute('role', 'heading');
      this.setAttribute('aria-level', this.level);
    }

    const classes = classMap({
      heading: true,
      [`style--${this.levelStyle} ${this.color}`]: true,
    });

    switch (this.level) {
      case 1:
        return html`<h1 class="${classes}" id="${ifDefined(this.id)}"><slot></slot></h1>`;
      case 2:
        return html`<h2 class="${classes}" id="${ifDefined(this.id)}"><slot></slot></h2>`;
      case 3:
        return html`<h3 class="${classes}" id="${ifDefined(this.id)}"><slot></slot></h3>`;
      case 4:
        return html`<h4 class="${classes}" id="${ifDefined(this.id)}"><slot></slot></h4>`;
      case 5:
        return html`<h5 class="${classes}" id="${ifDefined(this.id)}"><slot></slot></h5>`;
      case 6:
        return html`<h6 class="${classes}" id="${ifDefined(this.id)}"><slot></slot></h6>`;
      default:
        return html`<span class="${classes}" id="${ifDefined(this.id)}"><slot></slot></span>`;
    }
  }
}
customElements.define('hf-heading', Heading);
